import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../Navbar";
import Dropdown from "./Dropdown";

export default function InvestPortfolio({ user }) {
    const navigate = useNavigate();

    const goNext = () => {
        navigate("/StockDef");
    };

    const goPrev = () => {
        navigate("/InvestFactors");
    };

    return (
        <div className="h-screen overflow-hidden">
            <Navbar user={user} />
            <Dropdown />
            <div className="w-full flex flex-col justify-center items-center overflow-hidden">
                <div className="text-[#000000] text-5xl m-4 font-bold">
                    Investment Portfolio
                </div>
                <span className="w-full h-0.5 bg-blueInFigma"></span>
                <div className="text-[#000000] text-3xl mt-3">
                    An Investment Portfolio is the collection of financial assets a person has.  It 
                </div>
                <div className="text-[#000000] text-3xl">
                    includes bonds, stocks, cash, savings, and real estate, but it may include more.  
                </div>
                <div className="text-[#000000] text-3xl">
                    Your portfolio is affected by your risk tolerance as a higher percentage of your 
                </div>
                <div className="text-[#000000] text-3xl">
                    assets will have a greater associated risk if you have a higher risk tolerance and 
                </div>
                <div className="text-[#000000] text-3xl">
                    vice versa.
                </div>
                <div className="text-[#000000] text-3xl mt-3">
                    Over time, as your investments grow and shrink, your portfolio can change.  
                </div>
                <div className="text-[#000000] text-3xl">
                    Rebalancing your portfolio is to manage your portfolio until it reaches a goal.  For 
                </div>
                <div className="text-[#000000] text-3xl">
                    instance, you had 30% stocks in your portfolio, and a few of your stocks grew 
                </div>
                <div className="text-[#000000] text-3xl">
                    over the course of 6 months.  Now, your portfolio has 40% stocks.  To go back to 
                </div>
                <div className="text-[#000000] text-3xl">
                    30% stocks in your portfolio, you need to sell some stocks.
                </div>
            </div>
            <button className="bg-[#73C4FC] text-[#FFFFFF] p-4 absolute bottom-[10%] right-[17.5%] text-3xl rounded-2xl"
                onClick={goNext}
            >
                Next
            </button>
            <button className="bg-blueInFigma text-[#FFFFFF] p-4 absolute bottom-[10%] left-[17.5%] text-3xl rounded-2xl"
                onClick={goPrev}
            >
                Prev
            </button>
        </div>
    );
}